/**
 * Template-level constants (autosave, etc.)
 */
export const AUTO_SAVE_ENABLED = false;
